import CurrencySwitch from "@/components/CurrencySwitch";
import { usdcInfo } from "@/constants/tokens";
import { useUserInfo } from "@/context/UserInfo";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import { shortenAddress } from "@/utils";
import { avatarImg } from "@/utils/avatars";
import { getDidName } from "@/utils/didName";
import { accAdd, formatAndToSignificantDigits } from "@/utils/formatBalance";
import { Box, Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const ActivityContent = ({ list }: { list: any[] }) => {
  const navigate = useNavigate();
  const { currencyUnit, usdToCurrency } = useCurrencyExchange();
  const { showUsd, handleSwitchCurrency, showBalance } = useUserInfo();
  const handleToReceipt = (order: any) => {
    console.log(order, "order");
    navigate(`/receipt/${order.id}`);
  };
  return (
    <Box
      sx={{
        alignItems: "center",
        marginTop: "20px",
        padding: "0 20px 0px",
        height: "100%",
      }}
    >
      <Flex justify={"center"}>
        <CurrencySwitch onChange={handleSwitchCurrency} checked={showUsd} />
      </Flex>
      <Box
        sx={{
          height: "calc(100% - 88px)",
          overflowY: "auto",
          marginTop: "20px",
        }}
      >
        {list.map((order, index) => {
          const showMonthTitle =
            index === 0 ||
            dayjs(order.createdAt).format("MMM.YYYY") !==
              dayjs(list[index - 1].createdAt).format("MMM.YYYY");

          return (
            <Box key={index} width={"100%"}>
              {showMonthTitle && (
                <Text
                  sx={{
                    padding: "16px 0",
                    borderBottom: "1px solid #FFD096",
                    color: "#FFD096",
                    fontSize: "18px",
                    fontWeight: 700,
                  }}
                >
                  {dayjs(order.createdAt).format("MMM.YYYY")}
                </Text>
              )}
              <Flex
                sx={{ padding: "16px 0", borderBottom: "1px solid #FFD096" }}
                align={"center"}
                onClick={() => handleToReceipt(order)}
              >
                <Flex align={"center"} gap={"10px"}>
                  <Text
                    sx={{
                      fontSize: "30px",
                    }}
                  >
                    {avatarImg(order.recipient.avatar)}
                  </Text>
                  <Text
                    sx={{
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {getDidName(order.recipient.didName)
                      ? getDidName(order.recipient.didName)
                      : shortenAddress(order.recipient.address)}
                  </Text>
                </Flex>
                <Box
                  sx={{
                    width: "150px",
                    marginLeft: "auto",
                  }}
                >
                  {showBalance ? (
                    <Text
                      sx={{
                        color: "#fff",
                        textAlign: "right",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      -
                      {formatAndToSignificantDigits(
                        usdToCurrency(
                          accAdd(
                            accAdd(order.orderAmount, order.taxAmount),
                            order.tipAmount
                          )
                        ),
                        usdcInfo.decimals
                      )}{" "}
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 700,
                        }}
                      >
                        {currencyUnit}
                      </span>
                    </Text>
                  ) : (
                    <Text
                      sx={{
                        color: "#fff",
                        textAlign: "right",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      ******
                    </Text>
                  )}
                  <Text
                    sx={{
                      color: "#fff",
                      textAlign: "right",
                      fontFamily: "DIN-MediumItalic",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {dayjs(order.createdAt).fromNow()}
                  </Text>
                </Box>
              </Flex>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ActivityContent;
